import { render, staticRenderFns } from "./LegendForm.vue?vue&type=template&id=85246086&"
import script from "./LegendForm.vue?vue&type=script&lang=js&"
export * from "./LegendForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports